<svg class="icon loader color-{{ color }}" [attr.width]="size" [attr.height]="size">
  <use xlink:href="#loading"></use>
</svg>
